import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/comics';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const slide = heroSlides[current];

  return (
    <section className="relative w-full h-screen min-h-[600px] overflow-hidden">
      {/* Background Images */}
      {heroSlides.map((s, i) => (
        <div
          key={s.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            i === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={s.bgImage}
            alt={s.title}
            className="w-full h-full object-cover"
            loading={i === 0 ? 'eager' : 'lazy'}
          />
        </div>
      ))}

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-background-50" />

      {/* Content */}
      <div className="relative z-10 w-full h-full flex flex-col justify-center px-6 md:px-16 lg:px-24 max-w-screen-xl mx-auto">
        <div className="max-w-3xl">
          <div className="mb-4">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-500/20 text-primary-400 text-xs font-medium border border-primary-500/30">
              热门推荐
            </span>
          </div>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-foreground-50 leading-tight mb-6 tracking-wide">
            韩漫大全下拉式免费
            <br />
            无遮挡沉浸阅读
            <br />
            纯粹漫画享受
          </h1>

          <p className="text-foreground-300 text-sm md:text-base leading-relaxed max-w-xl mb-10">
            海量韩漫资源，每日更新不停歇。热血、恋爱、奇幻、悬疑——你想要的都在这里。下拉式无遮挡阅读，加载迅速零干扰，专注每一格精彩故事。
          </p>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <Link
              to={`/comic/${slide.slug}`}
              className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap flex items-center gap-2 cursor-pointer"
            >
              开始阅读
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
            <Link
              to="/category/action"
              className="px-6 py-3.5 border border-foreground-300/30 text-foreground-200 rounded-full text-sm font-medium hover:border-foreground-200 hover:text-foreground-50 transition-all whitespace-nowrap cursor-pointer"
            >
              浏览分类
            </Link>
          </div>
        </div>

        {/* Slide Indicators */}
        <div className="absolute bottom-8 left-6 md:left-24 flex items-center gap-2">
          {heroSlides.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className={`h-1 rounded-full transition-all duration-300 cursor-pointer ${
                i === current ? 'w-8 bg-primary-500' : 'w-4 bg-foreground-500/50 hover:bg-foreground-400'
              }`}
              aria-label={`幻灯片 ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}